// extracted by mini-css-extract-plugin
module.exports = {"pageLayout":"LU","mainContent":"MU","activeSidebar":"NU","hydraPills":"OU"};